/**
 * Simple class for triggering functions at a certain scroll level based on a reference
 */
import {throttle} from "./utils.js"

const SC_UP = "up"
const SC_DOWN = "down"

export default class InView {

    constructor(config) {
        this.config = config ? config : {}
        this.window = window
        this.debounce = 20

        this.defaultConfig = {
            element: false,
            windowPosition: "bottom",
            inViewCallback() {
                //console.log("in view")
            },
            /**
             * Works with "withDirection" set to true
             */
            inViewCallbackFromBottom() {
                //console.log("in view")
            },
            notInViewCallback() {
                //console.log("not in view")
            },
            positionReference() {

            },
            positionReferenceBack() {

            },
            scrollingCallback() {

            },
            withThrottle: true,
            withDirection: false
        }

        this.config = Object.assign({}, this.defaultConfig, this.config)

        this._initEvents()
    }

    _initEvents() {
        this.lastScrollTop = 0
        this.scrollDirection = SC_DOWN
        if (this.config.withDirection) {
            if (this.config.withThrottle) {
                this.window.addEventListener('scroll', throttle(e => this.checkIfInViewWithDirection(e), this.debounce))
                this.window.addEventListener('resize', throttle(e => this.checkIfInViewWithDirection(e), this.debounce))
            } else {
                this.window.addEventListener('scroll', e => this.checkIfInViewWithDirection(e))
                this.window.addEventListener('resize', e => this.checkIfInViewWithDirection(e))
            }
            this.checkIfInViewWithDirection()
        } else {
            if (this.config.withThrottle) {
                this.window.addEventListener('scroll', throttle(e => this.checkIfInView(e), this.debounce))
                this.window.addEventListener('resize', throttle(e => this.checkIfInView(e), this.debounce))
            } else {
                this.window.addEventListener('scroll', e => this.checkIfInView(e))
                this.window.addEventListener('resize', e => this.checkIfInView(e))
            }
            this.checkIfInView()
        }
    }

    checkIfInViewWithDirection() {

        let scrollTop = this.window.scrollY

        if (scrollTop > this.lastScrollTop) {
            this.scrollDirection = SC_DOWN
        } else {
            this.scrollDirection = SC_UP
        }

        this.lastScrollTop = scrollTop

        let windowHeight = this.window.innerHeight
        let windowTopPosition = scrollTop
        let windowBottomPosition = (windowTopPosition + windowHeight)
        let windowPosition

        if (this.config.windowPosition === "bottom") {
            windowPosition = windowBottomPosition
        } else {
            windowPosition = windowTopPosition
        }

        this.config.scrollingCallback({
            windowHeight,
            windowTopPosition,
            windowBottomPosition,
            windowPosition,
            w: this.window,
            direction: this.scrollDirection
        })

        if (this.scrollDirection === SC_DOWN && windowPosition > this.config.positionReference()) {
            this.config.inViewCallback({
                windowHeight,
                windowTopPosition,
                windowBottomPosition,
                windowPosition,
                w: this.window
            })
        }

        if (windowPosition < this.config.positionReference()) {
            this.config.notInViewCallback({
                windowHeight,
                windowTopPosition,
                windowBottomPosition,
                windowPosition,
                w: this.window
            })
        }

        if (this.config.positionReferenceBack() !== false && this.scrollDirection === SC_UP && windowPosition < this.config.positionReferenceBack()) {
            this.config.inViewCallbackFromBottom({
                windowHeight,
                windowTopPosition,
                windowBottomPosition,
                windowPosition,
                w: this.window
            })
        }

    }

    checkIfInView() {

        let scrollTop = this.window.scrollY

        if (scrollTop > this.lastScrollTop) {
            this.scrollDirection = SC_DOWN
        } else {
            this.scrollDirection = SC_UP
        }

        this.lastScrollTop = scrollTop

        let windowHeight = this.window.innerHeight
        let windowTopPosition = scrollTop
        let windowBottomPosition = (windowTopPosition + windowHeight)
        let windowPosition

        if (this.config.windowPosition === "bottom") {
            windowPosition = windowBottomPosition
        } else {
            windowPosition = windowTopPosition
        }

        this.config.scrollingCallback({
            windowHeight,
            windowTopPosition,
            windowBottomPosition,
            windowPosition,
            w: this.window,
            direction: this.scrollDirection
        })

        if (windowPosition > this.config.positionReference()) {
            this.config.inViewCallback({
                windowHeight,
                windowTopPosition,
                windowBottomPosition,
                windowPosition,
                w: this.window
            })
        } else if (windowPosition < this.config.positionReferenceBack()) {
            this.config.notInViewCallback({
                windowHeight,
                windowTopPosition,
                windowBottomPosition,
                windowPosition,
                w: this.window
            })
        }

    }

}
